<template>
            <div class="paths">
                <div class="_1200">
                    <h1 class="path-main-head">מסלולי לימוד</h1>
                    <div v-if="userPaths && userPaths.length > 0">

                        <div v-if="userPaths[0].itemRefID" class="paths-wrapper">
                            <div class="path-box w-inline-block" v-for="path in userPaths" :key="path.itemRefID">
                                <ChaiBahemPath :title="path.value"  :id="path.itemRefID"/>
                            </div>
                        </div>

                        <div v-else class="paths-wrapper">
                            <div class="path-box w-inline-block" v-for="path in userPaths" :key="path._id">
                                <ChaiBahemPath :title="path.title" :description="path.description" :id="path._id"/>
                            </div>
                        </div>

                    </div>
                  <div v-else style="text-align: center">
                    <loader/>
                  </div>
                  <div class="path-action">
                    <router-link to="/settings" class="btn sign w-button" style="margin-bottom: 50px">הרשמה למסלולים נוספים</router-link>

                  </div>
                </div>
                <router-view/>
            </div>
</template>

<script>
    import ChaiBahemPath from "../components/chai_bahem_path";
    import {mapActions, mapGetters} from "vuex";
    import loader from "@/components/loader";

    export default {
        name: "paths",
        methods: {
            ...mapActions(["fetchUserPaths"])
        },
      data(){
          return {
            userPaths: []
          }
      },
        computed: {
            ...mapGetters(['getUser', 'getUserPaths'])},
      watch:{
          async getUser(){
             this.fetchUserPaths();
            console.log('this.getUserPaths in watch')
            console.log(this.getUserPaths)
            this.userPaths = this.getUserPaths;
          },
      },
      async mounted() {
            console.log('in mounted in paths')
          if(this.getUser) {
              console.log('I getUser')
              console.log(this.getUser)
              if(this.getUser.fullName){
                  console.log('I get fullName')
                  this.fetchUserPaths();
                  console.log('this.getUserPaths in mounted')
                  console.log(this.getUserPaths)
                  this.userPaths = this.getUserPaths;
              }

          }
      },
      components: {ChaiBahemPath, loader}
    };
</script>